import { ColumnConfigurationPresetOption } from "./interfaces/columnConfigurationPresetOption";

export const defaultAllColumns: ColumnConfigurationPresetOption = {
  id: -1,
  isPrivate: true,
  name: "Default - All Columns",
};
